// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const lineChart = "LineChart__lineChart__CneXC";
export const isMobile = "LineChart__isMobile__9gDB7";
export const limits = "LineChart__limits__r69Y5";
export const chartContainer = "LineChart__chartContainer__n8xSy";
export const chart = "LineChart__chart__ThXQ4";
export const line = "LineChart__line__UB33C";
export const memberLine = "LineChart__memberLine__KecYV LineChart__line__UB33C";
export const memberProjectionLine = "LineChart__memberProjectionLine__eE3JW LineChart__line__UB33C";
export const peersProjectionLine = "LineChart__peersProjectionLine__uxSVK LineChart__line__UB33C";
export const otherProjectionLine = "LineChart__otherProjectionLine__kKPk4 LineChart__line__UB33C";
export const peersLine = "LineChart__peersLine__bH7iO LineChart__line__UB33C";
export const otherLine = "LineChart__otherLine__ODwB8 LineChart__line__UB33C";
export const circle = "LineChart__circle__V1G-y";
export const memberDot = "LineChart__memberDot__mpwxl LineChart__circle__V1G-y";
export const memberDotHidden = "LineChart__memberDotHidden__u2GRr LineChart__circle__V1G-y";
export const peersDot = "LineChart__peersDot__BFww8 LineChart__circle__V1G-y";
export const peersDotHidden = "LineChart__peersDotHidden__MU8+p LineChart__circle__V1G-y";
export const otherDot = "LineChart__otherDot__7SrN6 LineChart__circle__V1G-y";
export const otherDotHidden = "LineChart__otherDotHidden__Ev0Mt LineChart__circle__V1G-y";
export const area = "LineChart__area__2RhvH";
export const maxValuesArea = "LineChart__maxValuesArea__sFx5M LineChart__area__2RhvH";
export const memberArea = "LineChart__memberArea__jKmEh LineChart__area__2RhvH";
export const memberProjectionArea = "LineChart__memberProjectionArea__TOa5s LineChart__area__2RhvH";
export const peersArea = "LineChart__peersArea__Yn2Jk LineChart__area__2RhvH";
export const otherArea = "LineChart__otherArea__lCYy6 LineChart__area__2RhvH";
export const peersProjectionArea = "LineChart__peersProjectionArea__qnFh3 LineChart__area__2RhvH";
export const otherProjectionArea = "LineChart__otherProjectionArea__0-TWk LineChart__area__2RhvH";
export const tooltip = "LineChart__tooltip__5hfwM";
export const tooltipUp = "LineChart__tooltipUp__B52Od";
export const tooltipDown = "LineChart__tooltipDown__+6JjY";
export const tooltipVisible = "LineChart__tooltipVisible__VuoXv";
export const defaultTooltips = "LineChart__defaultTooltips__3zUJK";
export const defaultTooltip = "LineChart__defaultTooltip__nKj4I LineChart__tooltip__5hfwM LineChart__tooltipVisible__VuoXv";
export const defaultTooltipsHidden = "LineChart__defaultTooltipsHidden__3kaSV";
export const limitLine = "LineChart__limitLine__UefrE";
export const majorLimitLine = "LineChart__majorLimitLine__8wYsj LineChart__limitLine__UefrE";
export const minorLimitLine = "LineChart__minorLimitLine__V7fkb LineChart__limitLine__UefrE";
export const limitLabel = "LineChart__limitLabel__sLAVk";
export const limitLabelMovedUp = "LineChart__limitLabelMovedUp__x9EVq";
export const limitLabelMovedDown = "LineChart__limitLabelMovedDown__86XEc";
export const majorLimitLabel = "LineChart__majorLimitLabel__OJi+Q LineChart__limitLabel__sLAVk";
export const minorLimitLabel = "LineChart__minorLimitLabel__nyTUi LineChart__limitLabel__sLAVk";
export const limitTitle = "LineChart__limitTitle__Xth8b font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const memberTheme = "LineChart__memberTheme__Ay+c4";
export const limitCaption = "LineChart__limitCaption__0MwFR font-faces__sansBold__vF+EN font-faces__sans__uCf65";
export const defaultHoverMarkers = "LineChart__defaultHoverMarkers__wKn6V";
export const defaultHoverMarkersHidden = "LineChart__defaultHoverMarkersHidden__CBJy-";
export const hoverMarker = "LineChart__hoverMarker__aFePm";
export const defaultHoverMarker = "LineChart__defaultHoverMarker__PLqvA";
export const axisX = "LineChart__axisX__GB3Gs";
export const divider = "LineChart__divider__mEAVR";
export const defaultTips = "LineChart__defaultTips__zFMuM";
export const defaultTipsHidden = "LineChart__defaultTipsHidden__jX491";
export const tip = "LineChart__tip__dfPNb font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const defaultTip = "LineChart__defaultTip__NUwY4 font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const section = "LineChart__section__nSPB4 font-faces__sansMedium__DqLMY font-faces__sans__uCf65";